"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationOfferStatus = void 0;
var AssignationOfferStatus;
(function (AssignationOfferStatus) {
    AssignationOfferStatus[AssignationOfferStatus["Created"] = 0] = "Created";
    AssignationOfferStatus[AssignationOfferStatus["Confirmed"] = 1] = "Confirmed";
    AssignationOfferStatus[AssignationOfferStatus["Cancelled"] = 2] = "Cancelled";
    AssignationOfferStatus[AssignationOfferStatus["Declined"] = 3] = "Declined";
})(AssignationOfferStatus || (exports.AssignationOfferStatus = AssignationOfferStatus = {}));
//# sourceMappingURL=assignation-offer-status.enum.js.map